<app-landing></app-landing>
<app-options></app-options>
<app-ranges-showcase></app-ranges-showcase>
<app-community></app-community>
<app-story></app-story>
